import { Box, Button, Link } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import palette from '../../../../shared/lib/theme/palette';
import { VerifyProps } from '../../app/interfaceTypes';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { SPAM_FOLDER_TEXT, WHODOICALL_URL, VERIFY_EMAIL_TITLE, VERIFY_EMAIL_BODY_PREFIX, VERIFY_EMAIL_BODY_SUFFIX, BUTTON_TEXT_BACK_TO_LOGIN } from '../../../../shared/lib/constants';
import { LINKS } from '../../app/constants';
import { useNavigate } from 'react-router-dom';
import PendingPromoAlert from '../common/PendingPromoAlert';

const Verify: FC<VerifyProps> = ({ email }) => {
  const { blackOne, blackTwo } = palette;
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate(LINKS.LOGIN_LINK);
  };

  return (
    <Box maxWidth={560} width="100%" textAlign="center" paddingX="10px">
      <PendingPromoAlert />

      <Typography variant="h4" mb={2} sx={{ color: blackOne }}>
        {VERIFY_EMAIL_TITLE}
      </Typography>
      <Typography variant="body2" sx={{ color: blackTwo, wordBreak: 'break-word' }}>
        {VERIFY_EMAIL_BODY_PREFIX}{email}{VERIFY_EMAIL_BODY_SUFFIX}
      </Typography>
      <Typography mt={1} variant="body2" sx={{ color: blackTwo, wordBreak: 'break-word' }}>
        {SPAM_FOLDER_TEXT}
      </Typography>
      <Typography mt={1} variant="body2" sx={{ color: blackTwo, wordBreak: 'break-word' }}>
        Mark <Link> {WHODOICALL_URL} </Link> as safe.
      </Typography>
      <Button onClick={handleBackToLogin} variant="text" sx={{ color: 'primary', mt: '24px', textTransform: 'none' }} startIcon={<ArrowBackIcon sx={{ color: 'primary' }} />}>
        {BUTTON_TEXT_BACK_TO_LOGIN}
      </Button>
    </Box>
  );
};

export default Verify;
